export default [
  // Extenders shared by the forum and the admin panel go here,
  // e.g. extra colour schemes: new Extend.ThemeMode().add('bimmerdock-dark', 'BimmerDock Dark')
];